// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.navbar-brand {
    white-space: normal;
    text-align: center;
    word-break: break-all;
  }
  
  html {
    font-size: 14px;
  }
  @media (min-width: 768px) {
    html {
      font-size: 16px;
    }
  }
  
  .box-shadow {
    box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05);
  }
  `, "",{"version":3,"sources":["webpack://./src/Assets/Css/Components/NavMenu.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;EACA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,8CAA8C;EAChD","sourcesContent":["a.navbar-brand {\n    white-space: normal;\n    text-align: center;\n    word-break: break-all;\n  }\n  \n  html {\n    font-size: 14px;\n  }\n  @media (min-width: 768px) {\n    html {\n      font-size: 16px;\n    }\n  }\n  \n  .box-shadow {\n    box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
